import { Component, OnInit, ViewChild, ElementRef } from '@angular/core';
import { STATUS_OBJECT } from 'src/app/dummy/status';
import { Router, ActivatedRoute } from '@angular/router';
import { PrintService } from 'src/app/services/print.service';
import { BOOK_STORE_TABS } from 'src/app/dummy/tab';
import { COLLECTION_NAME } from 'src/app/dummy/app';
// import { BookstoreStore } from 'src/app/stores/bookstore/bookstore.store';
import { EnrollmentStore } from 'src/app/stores/enrollment/enrollment.store';

@Component({
  selector: 'app-tutor',
  templateUrl: './tutor.component.html',
  styleUrls: ['./tutor.component.scss']
})

export class TutorComponent implements OnInit {
  @ViewChild('PRINT_TABLE', {static:false}) PRINT_TABLE: ElementRef;
  tabs = BOOK_STORE_TABS.TUTORS;
  DISPLAY_STATUS_KEY: any;

  constructor(
    private router: Router,
    private route: ActivatedRoute,
    public store: EnrollmentStore,
    public ps: PrintService,
  ) { }

  async ngOnInit() {
    this.route.params.subscribe(async (param) => {
      this.DISPLAY_STATUS_KEY = STATUS_OBJECT[param['id']];
      this.store.fetchData(COLLECTION_NAME.TUTOR, this.DISPLAY_STATUS_KEY.key)
    })
  }

  create() {
    this.router.navigate([`/enrollment/tutors/admission/draft`])
  }
  
  edit(item:any) {
    this.router.navigate([`/enrollment/tutors/admission/${item.key}`])
  }
}
